const AboutMain = () => {
  return (
    <>
      <div className="about-space">
        <div className="our-services-text">
          <h1 className="services-title">
            {" "}
            OM Oss På <br />
            Söder Renovering AB
          </h1>
          <p className="services-text">
            Kontakta oss om du har några frågor eller om du vill ha en offert.
          </p>
        </div>
      </div>
    </>
  );
};

export default AboutMain;
